// import React, { useState, useEffect } from "react";
// import { Link, useNavigate, useParams } from 'react-router-dom';
// import { CKEditor } from "@ckeditor/ckeditor5-react";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// import axios from 'axios';
// import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url, ACCESS_Role_ID, ACCESS_Log_In_User_Id } from '../../constants/apiConstants';
// import "../../assets/css/bootstrap.min.css";
// import "../../assets/css/fontawesome-all.min.css";
// import "../../assets/css/slick.css";
// import "../../assets/css/line-awesome.min.css";
// import "../../assets/css/main.css";
// import "../../assets/css/responsive.css";

// // Import images
// import DropDownIcon from "../../assets/images/icons/drop-down-svgrepo-com 1.svg";
// import EditIcon from "../../assets/images/icons/edit-4-svgrepo-com 1.svg";
// import EditImage from "../../assets/images/icons/edit-1-svgrepo-com.svg";
// import teacherImage from '../../assets/images/icons/teacehr_+.svg';
// import downArrowImage from '../../assets/images/icons/down-arrow-5-svgrepo-com (2) 4.svg'
// import UpImage from '../../assets/images/icons/down-arrow-5-svgrepo-com (2) 3.svg'
// import EditActiveIcon from "../../assets/images/icons/edit-4-svgrepo-com_active.svg";
// import CourseIcon from "../../assets/images/icons/course-diary-svgrepo-com.svg";
// import CourseActiveIcon from "../../assets/images/icons/course-diary-svgrepo-com_active.svg";
// import UploadIcon from "../../assets/images/icons/upload-square-svgrepo-com 1.svg";
// import UploadActiveIcon from "../../assets/images/icons/upload-square-svgrepo-com_active.svg";
// import AssignmentIcon from "../../assets/images/icons/return-order-svgrepo-com 1.svg";
// import AssignmentActiveIcon from "../../assets/images/icons/return-order-svgrepo-com_active.svg";
// import CertificateIcon from "../../assets/images/icons/certificate-check-svgrepo-com 1.svg";
// import CertificateActiveIcon from "../../assets/images/icons/certificate-check-svgrepo-com_active.svg";
// import MessageIcon from "../../assets/images/icons/email-envelope-letter-mail-message-svgrepo-com 1.svg";
// import MessageActiveIcon from "../../assets/images/icons/email-envelope-letter-mail_active.svg";
// import NotificationIcon from "../../assets/images/icons/notification-bing-svgrepo-com 1.svg";
// import ManageEditIcon from "../../assets/images/icons/manage_edit.svg";
// import ProfileImage from "../../assets/images/all/profiel.png";
// import SearchIcon from "../../assets/images/all/search.svg";
// import HistoryIconActive from "../../assets/images/icons/history-svgrepo-com_active.svg";
// import HistoryIcon from "../../assets/images/icons/history-svgrepo-com 1.svg";
// import mediaImage from '../../assets/images/icons/Frame 399.svg'
// import FeedImage from "../../assets/images/all/fedd.png";
// import { Footer } from "../../components";
// import TeacherSideBar from '../../components/TeacherSidebar'
// import CommanStudentTeacherHeader from "../../components/CommanStudentTeacherHeader";
// import CommanInstitute from "../../components/CommanInstitute";


// const InstituteEditChennal = () => {
//     const navigate = useNavigate();
//     const [selectedFile, setSelectedFile] = useState(null);
//     const [courses, setCourses] = useState([]);
//     const handleFileChange = (e) => {
//         setSelectedFile(e.target.files[0]);
//     };
//     const [profileimg, setProfileimg] = useState("");

//     const [formData, setFormData] = useState({
//         course_title: "",
//         course_description: "",
//         course_category: "",
//         course_duration: "",
//         course_requirements: "",
//         topic_cover: "",
//         select_language: "",
//         currency: "",
//         course_price: "",
//         course_discount_price: "",
//         course_discount_percent: "",


//     });
//     const [fileData, setFileData] = useState({
//         image: null,
//         // video: null,
//     });

//     // Handle CKEditor content change
//     const handleEditorChange = (event, editor) => {
//         setFormData({ ...formData, course_description: editor.getData() });
//     };

//     const user_id = ACCESS_Log_In_User_Id();
//     const { id } = useParams();
//     const currentUserId = user_id ? user_id : id;

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData((prevData) => ({
//             ...prevData,
//             [name]: value,
//         }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         const formdata = new FormData();
    
//         const user_id = ACCESS_Log_In_User_Id();
//         const role_id = ACCESS_Role_ID();
    
//         formdata.append("user_id", user_id); // ensure it's a string
//         formdata.append("role_id", role_id);
    
//         formdata.append("course_title", formData.course_title);
//         formdata.append("course_description", formData.course_description);
//         formdata.append("course_category", formData.course_category);
//         formdata.append("course_duration", formData.course_duration);
//         formdata.append("course_requirements", formData.course_requirements);
//         formdata.append("topic_cover", formData.topic_cover);
//         formdata.append("select_language", formData.select_language);
//         formdata.append("currency", formData.currency);
//         formdata.append("course_price", formData.course_price);
//         formdata.append("course_discount_price", formData.course_discount_price);
//         formdata.append("course_discount_percent", formData.course_discount_percent);
//         formdata.append("status", "0"); // always append strings
    
//         if (selectedFile) {
//             formdata.append("courseImage", selectedFile);
//         }
    
//         // Debug: log the form data
//         for (let [key, value] of formdata.entries()) {
//             console.log(`${key}:`, value);
//         }
    
//         try {
//             const response = await axios.post(`${API_BASE_URL}/updateCoursesDetails/${id}`, formdata);
//             console.log("Response:", response.data);
    
//             if (response.data.code == 200) {
//                 alert(`Success: ${response.data.message}`);
//                 navigate("/instituteCourse");
//             } else {
//                 alert("Failed to submit the form!");
//             }
//         } catch (error) {
//             console.error("Error submitting the form:", error);
//             alert("An error occurred!");
//         }
//     };
    

//     // const CreateInstituteCourse = async () => {
//     //     console.log("Course create function called");
//     //     try {
//     //         // const id = streamDetails['id'] ?? null;
//     //         const response = await axios.post(`${API_BASE_URL}/createCoursesDetailsData/${id}`, {
//     //             user_id: ACCESS_Log_In_User_Id(),
//     //             role_id: ACCESS_Role_ID(),
//     //             stream_name: streamDetails.stream_name,
//     //             fee: streamDetails.fee,
//     //             year: streamDetails.year,
//     //             stream_bio: streamDetails.stream_bio,
//     //         });
//     //         // setStreamDetails(response.data);
//     //         // setIsSectionOpen(false)
//     //         // setShowOptions(!isSectionOpen)
//     //     } catch (error) {
//     //         // console.error('Error saving profile:', error);
//     //     }
//     //     // setStreamDetails(!StreamEditable);
//     //     // setIsSectionOpen(false)
//     //     // setShowOptions(!isSectionOpen)
//     //     // fetchBioInfoDetails();
//     //     // fetchPersonalInfoDetails();
//     //     // fetchOtherInfoDetails();
//     //     // fetchStreamDetails();
//     // };

//     const fetchProfile = async () => {
//         // const user_id = ACCESS_Log_In_User_Id();
//         axios.get(`${API_BASE_URL}/getprofileImgDetails?user_id=${currentUserId}`)
//             .then(function (response) {
//                 console.log(response);
//                 if (response.data.code == 200) {
//                     console.log(response.data.data[0]);
//                     setProfileimg(response.data.data[0]);
//                 }
//             })
//             .catch(function (error) {
//                 console.log(error);
//             });
//     };

//        const getCourseDetails = async () => {
//             try {
//             const response = await axios.get(`${API_BASE_URL}/getCoursesDetailsById/${id}`);
//             console.log("12312312312321213",response.data[0]);
//             const courseData = response.data[0];
//             // if (response.data.code === 200) {
//                 setCourses(courseData); // Set video data
//                 setFormData({
//                     course_title: courseData.course_title || "",
//                     course_description: courseData.course_description || "",
//                     course_category: courseData.course_category || "",
//                     course_duration: courseData.course_duration || "",
//                     course_requirements: courseData.course_requirements || "",
//                     topic_cover: courseData.topic_cover || "",
//                     select_language: courseData.select_language || "",
//                     currency: courseData.currency || "",
//                     course_price: courseData.course_price || "",
//                     course_discount_price: courseData.course_discount_price || "",
//                     course_discount_percent: courseData.course_discount_percent || "",
//                 });
//                  setSelectedFile({ name: courseData.course_image_name });

//             // } else {
//             //     // setError("Failed to fetch video details.");
//             // }
//             } catch (err) {
//             console.error(err);
//             // setError("An error occurred while fetching data.");
//             } finally {
//             // setLoading(false); // Stop loading indicator
//             }
//         };
    

//     // // Fetch data on component mount
//     useEffect(() => {
//         alert(id)
//         fetchProfile();
//         getCourseDetails()
//     }, []);
//     console.log("render data item",courses,formData)
//     return (
//         <div className="bg_dashboard">
//             {/* Mobile Menu */}
//             <CommanStudentTeacherHeader />

//             {/* Main Content */}
//             <div className="container">
//                 <div className="row">
//                     {/* Sidebar */}

//                     <CommanInstitute />
//                     <div className="col-sm-9 col-md-12 col-xl-9 px-md-5 ps-xl-5 ">
//                         <form onSubmit={handleSubmit} encType="multipart/form-data">
//                             <div className="col-sm-12 col-md-12 col-xl-12 px-md-5 ps-xl-5 ">
//                                 <div className="row mt-5">
//                                     <div className="col-md-9 ps-0">
//                                         <div className="search-box dashboard_search">
//                                             <input type="text" className="common-input common-input--lg dashboard_search_input pill shadow-sm auto-suggestion-input" placeholder="Search" />
//                                             <button type="submit" className="btn btn-main spl_burron  border-0"><img src={SearchIcon} alt="" /></button>
//                                         </div>
//                                     </div>
//                                     <div className="col-md-2 text-xl-center  mt-3">
//                                         <img src={NotificationIcon} alt="" />
//                                     </div>
//                                     <div className="col-md-1">
//                                         <div className="dashboard_profile ms-auto">
//                                             <img src={profileimg && profileimg.profile_image_path ? `${Image_Base_Url}${profileimg.profile_image_path}` : ProfileImage} alt="" />
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <p className="learm-tilte my-3">Course Edit/Update Page</p>
//                                 <div className="row p-0 ">
//                                     <div className="dashboard_card p-0">
//                                         <div className="row py-4 px-5">
//                                             <div className="">
//                                                 <div className="row px-0 px-sm-3">
//                                                     <div className="col-sm-12 mt-4">
//                                                         <label for="course_title" className="profile_text_2 mb-3">Course Title</label>
//                                                         <div className="position-relative">
//                                                             <input type="text" className="common-input common-input--md dash_borad_input_1" id="course_title" name="course_title" value={formData.course_title} onChange={handleChange} placeholder="e.g. The Complete AP & College Physics Cou" maxLength="60" />
//                                                             <span className="character-count position-absolute" style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }}>0/60</span>
//                                                         </div>
//                                                     </div>

//                                                     <div className="col-sm-12 mt-4">
//                                                         <label for="course_description" className="profile_text_2 mb-3">Course Description</label>
//                                                         <div className="position-relative">
//                                                             <CKEditor editor={ClassicEditor} data={formData.course_description} config={{ height: "800px" }} onChange={handleEditorChange} />

//                                                             {/* <textarea className="common-input common-input--md dash_borad_input_1" id="course_description" name="course_description" value={formData.course_description} onChange={handleChange} style={{ height: '300px' }} placeholder="Simply dummy text of the printing and typesetting industry..." maxLength="300"></textarea> */}
//                                                             {/* <span className="character-count position-absolute" style={{ right: '10px', bottom: '10px' }}>200/300</span> */}
//                                                         </div>
//                                                     </div>

//                                                     {/* <div className="col-sm-12 mt-4">
//                                         <label for="courseCategory" className="profile_text_2 mb-3">Course Category</label>
//                                         <div className="position-relative">
//                                             <select className="common-input common-input--md dash_borad_input_1" id="courseCategory">
//                                                 <option selected disabled>Choose a Category</option>
//                                             </select>
//                                         </div>
//                                     </div> */}

//                                                     {/* <div className="col-sm-12 mt-4">
//                                         <label for="courseDuration" className="profile_text_2 mb-3">Course Duration</label>
//                                         <div className="position-relative">
//                                             <select className="common-input common-input--md dash_borad_input_1" id="courseDuration">
//                                                 <option selected disabled>Choose Time</option>
//                                             </select>
//                                         </div>
//                                     </div> */}

//                                                     {/* <div className="col-sm-12 mt-4">
//                                         <label for="courseRequirements" className="profile_text_2 mb-3">Course Requirements</label>
//                                         <p>List the required skills, experience, tools or equipment learners should have prior to taking your course. If there are no requirements, use this space as an opportunity to lower the barrier for beginners.</p>
//                                         <div className="position-relative">
//                                             <textarea className="common-input common-input--md dash_borad_input_1" id="courseRequirements" rows="3" placeholder="e.g. Simply dummy text of the printing and typesetting industry..."></textarea>
//                                         </div>
//                                         <button type="button" className="me-2"><img src={teacherImage} alt=""/></button> <span>Add more outcomes</span>
//                                     </div> */}
//                                                     <div className="col-sm-12 mt-4">
//                                                         <label for="course_category" className="profile_text_2 mb-3">Course Category</label>
//                                                         <div className="position-relative">
//                                                             <input type="text" className="common-input common-input--md dash_borad_input_1" id="course_category" name="course_category" value={formData.course_category} onChange={handleChange} placeholder="e.g. The Complete AP & College Physics Cou" maxLength="60" />
//                                                             <span className="character-count position-absolute" style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }}>0/60</span>
//                                                         </div>
//                                                     </div>
//                                                     <div className="col-sm-12 mt-4">
//                                                         <label for="course_duration" className="profile_text_2 mb-3">Course Duration</label>
//                                                         <div className="position-relative">
//                                                             <input type="text" className="common-input common-input--md dash_borad_input_1" id="course_duration" name="course_duration" value={formData.course_duration} onChange={handleChange} placeholder="e.g. The Complete AP & College Physics Cou" maxLength="60" />
//                                                             <span className="character-count position-absolute" style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }}>0/60</span>
//                                                         </div>
//                                                     </div>
//                                                     <div className="col-sm-12 mt-4">
//                                                         <label for="course_requirements" className="profile_text_2 mb-3">Course Requirements</label>
//                                                         <div className="position-relative">
//                                                             <input type="text" className="common-input common-input--md dash_borad_input_1" id="course_requirements" name="course_requirements" value={formData.course_requirements} onChange={handleChange} placeholder="e.g. The Complete AP & College Physics Cou" maxLength="60" />
//                                                             <span className="character-count position-absolute" style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }}>0/60</span>
//                                                         </div>
//                                                     </div>
                                                    
//                                                     <div className="col-sm-12 mt-4">
//                                                         <label for="topicsCovered" className="profile_text_2 mb-3">Topics Covered</label>
//                                                         <div className="position-relative">
//                                                             <select className="common-input common-input--md dash_borad_input_1" id="topicsCovered" name="topicCovered">
//                                                                 <option disabled>Select Topics </option>
//                                                                 <option value="1">PHP </option>
//                                                             </select>
//                                                         </div>
//                                                     </div>
//                                                     <div className="col-sm-12 mt-4">
//                                                         <label for="select_language" className="profile_text_2 mb-3">Select Language</label>
//                                                         <div className="position-relative">
//                                                             <input type="text" className="common-input common-input--md dash_borad_input_1" id="select_language" name="select_language" value={formData.select_language} onChange={handleChange} placeholder="e.g. The Complete AP & College Physics Cou" maxLength="60" />
//                                                             <span className="character-count position-absolute" style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }}>0/60</span>
//                                                         </div>
//                                                     </div>
//                                                     <div className="col-sm-12 mt-4">
//                                                         <label for="currency" className="profile_text_2 mb-3">Currency</label>
//                                                         <div className="position-relative">
//                                                             <input type="text" className="common-input common-input--md dash_borad_input_1" id="currency" name="currency" value={formData.currency} onChange={handleChange} placeholder="e.g. The Complete AP & College Physics Cou" maxLength="60" />
//                                                             <span className="character-count position-absolute" style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }}>0/60</span>
//                                                         </div>
//                                                     </div>
//                                                     <div className="col-sm-12 mt-4">
//                                                         <label for="course_price" className="profile_text_2 mb-3">Course Price</label>
//                                                         <div className="position-relative">
//                                                             <input type="text" className="common-input common-input--md dash_borad_input_1" id="course_price" name="course_price" value={formData.course_price} onChange={handleChange} placeholder="e.g. The Complete AP & College Physics Cou" maxLength="60" />
//                                                             <span className="character-count position-absolute" style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }}>0/60</span>
//                                                         </div>
//                                                     </div>
//                                                     <div className="col-sm-12 mt-4">
//                                                         <label for="course_discount_price" className="profile_text_2 mb-3">Course Discount Price</label>
//                                                         <div className="position-relative">
//                                                             <input type="text" className="common-input common-input--md dash_borad_input_1" id="course_discount_price" name="course_discount_price" value={formData.course_discount_price} onChange={handleChange} placeholder="e.g. The Complete AP & College Physics Cou" maxLength="60" />
//                                                             <span className="character-count position-absolute" style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }}>0/60</span>
//                                                         </div>
//                                                     </div>
//                                                     <div className="col-sm-12 mt-4">
//                                                         <label for="course_discount_percent" className="profile_text_2 mb-3">Course Discount Percent</label>
//                                                         <div className="position-relative">
//                                                             <input type="text" className="common-input common-input--md dash_borad_input_1" id="course_discount_percent" name="course_discount_percent" value={formData.course_discount_percent} onChange={handleChange} placeholder="e.g. The Complete AP & College Physics Cou" maxLength="60" />
//                                                             <span className="character-count position-absolute" style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }}>0/60</span>
//                                                         </div>
//                                                     </div>
//                                                     <div className="col-sm-12 mt-4">
//                                                         <label htmlFor="mediaUpload" className="profile_text_2 mb-3 learn-title2"> Upload Media </label>
//                                                         <div className="position-relative">
//                                                             <input type="text" className="common-input common-input--md dash_borad_input_1" id="course_title" placeholder={selectedFile ? selectedFile.name : "No file selected"} maxLength="60" readOnly />
//                                                             <span className="character-count position-absolute" style={{ right: '10px', top: '50%', transform: 'translateY(-50%)', }} >
//                                                                 <label htmlFor="mediaFile" className="media-btn" style={{ cursor: 'pointer' }}>
//                                                                     <img className="me-2" src={mediaImage} alt="Media Icon" />
//                                                                     <span>Media</span>
//                                                                 </label>
//                                                                 <input type="file" id="mediaFile" style={{ display: 'none' }} onChange={handleFileChange} name="courseImage" />
//                                                             </span>
//                                                         </div>

//                                                         <label className="note learm-tilte2 fw-500 font-14">
//                                                             Note: All files should be at least 720p and less than 4.0 GB.
//                                                         </label>

//                                                         {/* <div className="mt-3 text-end">
//                                             <button onClick={handleUploadClick} className="btn btn_cousre bg-main-btn text-white py-2 px-4 fw-500 font-20" > Upload File </button>
//                                         </div> */}
//                                                     </div>
//                                                     {/* <div className="col-sm-12 mt-4 ">
//                                         <label for="courseImage" className="profile_text_2 mb-3">Course Image </label>
//                                         <p>Upload your course image here.It must meet our course image quality standards to be accepted.Important guidelines :750x422 pixels;.jpg,.jpeg.,.gif,or.png.no text on the image.</p>
//                                         <div className="height_370"> </div>
//                                         <div className="mt-3 text-end">
//                                             <button className="btn btn_cousre bg-main-btn text-white py-2 px-4 fw-500 font-20">Upload File</button>
//                                         </div>
//                                     </div> */}

//                                                     {/* <div className="col-sm-12 mt-4 ">
//                                         <label for="promoVideo" className="profile_text_2 mb-3 ">Promotional Video </label>
//                                         <p>Your promo video is a quick and compelling way for students to preview what they’ll learn in your course.Students considering your course are more likely to enroll if your promo video is well-made.</p>
//                                         <div className="height_370"> </div>
//                                         <div className="mt-3 text-end">
//                                             <button className="btn btn_cousre bg-main-btn text-white py-2 px-4 fw-500 font-20">Upload File</button>
//                                         </div>
//                                     </div> */}
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="row mb-5 mt-3">
//                                     <div className="col-sm-12 d-flex justify-content-between">
//                                         <span className="learm-tilte2 font-16" onClick={() => navigate("/instituteCourse")}><img src={downArrowImage} alt="" /> Previous</span>
//                                         <button className="btn btn_cousre bg-main-btn text-white py-2 px-4 fw-500 font-20" type="submit">Save</button>
//                                         {/* <span className="learm-tilte2 font-16" onClick={() => navigate("/CourseStructure")}>Next <img src={UpImage} alt="" /></span> */}
//                                     </div>
//                                 </div>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             </div>
//             <Footer />
//         </div>
//     );
// };

// export default InstituteEditChennal;




import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import axios from 'axios';
import {
  API_BASE_URL,
  Image_Base_Url,
  ACCESS_Role_ID,
  ACCESS_Log_In_User_Id,
} from '../../constants/apiConstants';
import "../../assets/css/bootstrap.min.css";
import "../../assets/css/fontawesome-all.min.css";
import "../../assets/css/slick.css";
import "../../assets/css/line-awesome.min.css";
import "../../assets/css/main.css";
import "../../assets/css/responsive.css";

// Images
import mediaImage from '../../assets/images/icons/Frame 399.svg';
import NotificationIcon from "../../assets/images/icons/notification-bing-svgrepo-com 1.svg";
import ProfileImage from "../../assets/images/all/profiel.png";
import SearchIcon from "../../assets/images/all/search.svg";
import downArrowImage from '../../assets/images/icons/down-arrow-5-svgrepo-com (2) 4.svg';
import { Footer } from "../../components";
import CommanStudentTeacherHeader from "../../components/CommanStudentTeacherHeader";
import CommanInstitute from "../../components/CommanInstitute";

const InstituteEditChennal = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const user_id = ACCESS_Log_In_User_Id();
  const currentUserId = user_id || id;

  const [profileimg, setProfileimg] = useState("");
  const [selectedFile, setSelectedFile] = useState([]);
  const [courses, setCourses] = useState({});
  const [formData, setFormData] = useState({
    course_title: "",
    course_description: "",
    course_category: "",
    course_duration: "",
    course_requirements: "",
    topic_cover: "",
    select_language: "",
    currency: "",
    course_price: "",
    course_discount_price: "",
    course_discount_percent: "",
    top_institute: "",
    entrance_exam: "",
    professional_experience: "",
        lectures: "",
        quizes: "",
        location: "",
        students: "",
        certificate: "",
        assessments: "",
  });

  // const handleFileChange = (e) => {
  //   setSelectedFile(e.target.files[0]);
  // };

  const handleFileChange = (e) => {
    const filesArray = Array.from(e.target.files);
    setSelectedFile(filesArray);
};

  const handleEditorChange = (event, editor) => {
    setFormData((prev) => ({
      ...prev,
      course_description: editor.getData(),
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formdata = new FormData();

    formdata.append("user_id", String(user_id));
    formdata.append("role_id", String(ACCESS_Role_ID()));
    Object.keys(formData).forEach((key) => {
      formdata.append(key, formData[key]);
    });
    formdata.append("status", "0");

    // if (selectedFile) {
    //   formdata.append("courseImage[]", selectedFile);
    // }

    if (selectedFile && selectedFile.length > 0) {
      selectedFile.forEach((file, index) => {
          console.log("dndjndndmndd",file)
          formdata.append("courseImage[]", file);
        // OR use array-style if your API expects it:
        // formDataToSend.append(`courseImage[${index}]`, file);
      });
    }

    try {
      const response = await axios.post(`${API_BASE_URL}/updateCoursesDetails/${id}`, formdata);
      if (response.data.code == 200) {
        alert(`Success: ${response.data.message}`);
        navigate("/instituteCourse");
      } else {
        alert("Failed to update the course!");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("An error occurred!");
    }
  };

  const fetchProfile = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/getprofileImgDetails?user_id=${currentUserId}`);
      if (res.data.code === 200 && res.data.data[0]) {
        setProfileimg(res.data.data[0]);
      }
    } catch (error) {
      console.error("Profile fetch error:", error);
    }
  };

  const getCourseDetails = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/getCoursesDetailsById/${id}`);
      const courseData = response.data[0];
      setCourses(courseData);
      setFormData({
        course_title: courseData.course_title || "",
        course_description: courseData.course_description || "",
        course_category: courseData.course_category || "",
        course_duration: courseData.course_duration || "",
        course_requirements: courseData.course_requirements || "",
        topic_cover: courseData.topic_cover || "",
        select_language: courseData.select_language || "",
        currency: courseData.currency || "",
        course_price: courseData.course_price || "",
        course_discount_price: courseData.course_discount_price || "",
        course_discount_percent: courseData.course_discount_percent || "",
        top_institute: courseData.top_institute || "",
        entrance_exam: courseData.entrance_exam || "",
        professional_experience:  courseData.professional_experience || "",
        lectures: courseData.lectures || "",
        quizes:  courseData.quizes || "",
        location:  courseData.location || "",
        students:  courseData.students || "",
        certificate:  courseData.certificate || "",
        assessments:  courseData.assessments || "",
      });
    } catch (error) {
      console.error("Error fetching course details", error);
    }
  };

  useEffect(() => {
    fetchProfile();
    getCourseDetails();
  }, []);

  return (
    <div className="bg_dashboard">
      <CommanStudentTeacherHeader />
      <div className="container">
        <div className="row">
          <CommanInstitute />
          <div className="col-xl-9 px-md-5">
            <form onSubmit={handleSubmit} encType="multipart/form-data">
              <div className="row mt-5">
                <div className="col-md-9 ps-0">
                  <div className="search-box dashboard_search">
                    <input type="text" className="common-input dashboard_search_input pill shadow-sm" placeholder="Search" />
                    <button type="submit" className="btn btn-main border-0">
                      <img src={SearchIcon} alt="" />
                    </button>
                  </div>
                </div>
                <div className="col-md-2 mt-3 text-xl-center">
                  <img src={NotificationIcon} alt="" />
                </div>
                <div className="col-md-1">
                  <div className="dashboard_profile ms-auto">
                    <img src={profileimg?.profile_image_path ? `${Image_Base_Url}${profileimg.profile_image_path}` : ProfileImage} alt="profile" />
                  </div>
                </div>
              </div>

              <p className="learm-tilte my-3">Course Edit/Update Page</p>

              <div className="dashboard_card p-4">
                <div className="row">
                  <div className="col-sm-12 mt-4">
                    <label className="profile_text_2 mb-3">Course Title</label>
                    <input type="text" className="common-input" name="course_title" value={formData.course_title} onChange={handleChange} />
                  </div>

                  <div className="col-sm-12 mt-4">
                    <label className="profile_text_2 mb-3">Course Description</label>
                    <CKEditor editor={ClassicEditor} data={formData.course_description} onChange={handleEditorChange} />
                  </div>

                  <div className="col-sm-12 mt-4">
                    <label className="profile_text_2 mb-3">Course Category</label>
                    <input type="text" className="common-input" name="course_category" value={formData.course_category} onChange={handleChange} />
                  </div>

                  <div className="col-sm-12 mt-4">
                    <label className="profile_text_2 mb-3">Course Duration</label>
                    <input type="text" className="common-input" name="course_duration" value={formData.course_duration} onChange={handleChange} />
                  </div>

                  <div className="col-sm-12 mt-4">
                    <label className="profile_text_2 mb-3">Course Requirements</label>
                    <input type="text" className="common-input" name="course_requirements" value={formData.course_requirements} onChange={handleChange} />
                  </div>

                  {/* <div className="col-sm-12 mt-4">
                    <label className="profile_text_2 mb-3">Topics Covered</label>
                    <select className="common-input" name="topic_cover" value={formData.topic_cover} onChange={handleChange}>
                      <option disabled>Select Topics</option>
                      <option value="PHP">PHP</option>
                    </select>
                  </div> */}

                  <div className="col-sm-12 mt-4">
                    <label className="profile_text_2 mb-3">Topics Covered</label>
                    <input type="text" className="common-input" name="topic_cover" value={formData.topic_cover} onChange={handleChange} />
                  </div>

                  <div className="col-sm-12 mt-4">
                    <label className="profile_text_2 mb-3">Language</label>
                    <input type="text" className="common-input" name="select_language" value={formData.select_language} onChange={handleChange} />
                  </div>

                  <div className="col-sm-12 mt-4">
                    <label className="profile_text_2 mb-3">Currency</label>
                    <input type="text" className="common-input" name="currency" value={formData.currency} onChange={handleChange} />
                  </div>

                  <div className="col-sm-12 mt-4">
                    <label className="profile_text_2 mb-3">Course Price</label>
                    <input type="text" className="common-input" name="course_price" value={formData.course_price} onChange={handleChange} />
                  </div>

                  <div className="col-sm-12 mt-4">
                    <label className="profile_text_2 mb-3">Course Discount Price</label>
                    <input type="text" className="common-input" name="course_discount_price" value={formData.course_discount_price} onChange={handleChange} />
                  </div>

                  <div className="col-sm-12 mt-4">
                    <label className="profile_text_2 mb-3">Discount Percent</label>
                    <input type="text" className="common-input" name="course_discount_percent" value={formData.course_discount_percent} onChange={handleChange} />
                  </div>

                  <div className="col-sm-12 mt-4">
                    <label className="profile_text_2 mb-3">Top Institute</label>
                    <input type="text" className="common-input" name="top_institute" value={formData.top_institute} onChange={handleChange} />
                  </div>
                  <div className="col-sm-12 mt-4">
                    <label className="profile_text_2 mb-3">Entrance Exam</label>
                    <input type="text" className="common-input" name="entrance_exam" value={formData.entrance_exam} onChange={handleChange} />
                  </div>

                  <div className="col-sm-12 mt-4">
                    <label className="profile_text_2 mb-3">Professional Experience</label>
                    <input type="text" className="common-input" name="professional_experience" value={formData.professional_experience} onChange={handleChange} />
                  </div>
                  <div className="col-sm-12 mt-4">
                    <label className="profile_text_2 mb-3">Lectures</label>
                    <input type="text" className="common-input" name="lectures" value={formData.lectures} onChange={handleChange} />
                  </div>
                  <div className="col-sm-12 mt-4">
                    <label className="profile_text_2 mb-3">Quizes</label>
                    <input type="text" className="common-input" name="quizes" value={formData.quizes} onChange={handleChange} />
                  </div>
                  <div className="col-sm-12 mt-4">
                    <label className="profile_text_2 mb-3">Location</label>
                    <input type="text" className="common-input" name="location" value={formData.location} onChange={handleChange} />
                  </div>
                  <div className="col-sm-12 mt-4">
                    <label className="profile_text_2 mb-3">Students</label>
                    <input type="text" className="common-input" name="students" value={formData.students} onChange={handleChange} />
                  </div>
                  <div className="col-sm-12 mt-4">
                    <label className="profile_text_2 mb-3">Certificate</label>
                    <input type="text" className="common-input" name="certificate" value={formData.certificate} onChange={handleChange} />
                  </div>
                  <div className="col-sm-12 mt-4">
                    <label className="profile_text_2 mb-3">Assessments</label>
                    <input type="text" className="common-input" name="assessments" value={formData.assessments} onChange={handleChange} />
                  </div>

                  <div className="col-sm-12 mt-4">
                    <label className="profile_text_2 mb-3">Upload Media</label>
                    <div className="position-relative">
                     <input
    type="text"
    className="common-input common-input--md dash_borad_input_1"
    id="courseTitle"
    placeholder={
      selectedFile.length > 0
        ? selectedFile.map(file => file.name).join(', ')
        : "No file selected"
    }
    maxLength="60"
    readOnly
  />
                      <label htmlFor="mediaFile" className="media-btn" style={{ position: "absolute", right: "10px", top: "10px", cursor: "pointer" }}>
                        <img src={mediaImage} alt="upload" />
                      </label>
                      <input type="file" id="mediaFile" style={{ display: 'none' }}   multiple onChange={handleFileChange} />
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mb-5 mt-3">
                <div className="col-sm-12 d-flex justify-content-between">
                  <span className="learm-tilte2 font-16" onClick={() => navigate("/instituteCourse")}><img src={downArrowImage} alt="" /> Previous</span>
                  <button className="btn bg-main-btn text-white py-2 px-4 fw-500 font-20" type="submit">Save</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default InstituteEditChennal;

